import ImgConsumption from "../images/app_campaign/illustration-consumption.svg";
import ImgFlower from "../images/app_campaign/illustration-flower.svg";
import ImgFuelBack from "../images/app_campaign/illustration-fuelback.svg";
import ImgFueling from "../images/app_campaign/illustration-fueling.svg";
import ImgLoyaltyDiscounts from "../images/app_campaign/illustration-loyalty-discounts.svg";
import ImgShop from "../images/app_campaign/illustration-shop.svg";
import ImgSmartElectricity from "../images/app_campaign/illustration-smart-electricity.svg";
import ImgCoffee from "../images/app_campaign/illustration-coffee.svg";
import ImgElectricity from "../images/app_campaign/illustration-electricity.svg";
import ImgStreetFood from "../images/app_campaign/illustration-streetfood.svg";
import ImgWarmFood from "../images/app_campaign/illustration-warm-food.svg";
import ImgBurgerCoffee from "../images/app_campaign/illustration-burgercoffee.svg";
import ImgChristmas from "../images/app_campaign/illustration-christmas.svg";
import ImgMeatballs from "../images/app_campaign/illustration-meatballs.svg";
import ImgWrapilla from "../images/app_campaign/illustration-wrapilla.svg";
import ImgBurger from "../images/app_campaign/illustration-burger.svg";
import ImgGrillburger from "../images/app_campaign/illustration-grillburger.svg";

export const AppCampaignIllustrationsMap = {
    'illustration-consumption': ImgConsumption,
    'illustration-flower': ImgFlower,
    'illustration-fuelback': ImgFuelBack,
    'illustration-fueling': ImgFueling,
    'illustration-loyalty-discounts': ImgLoyaltyDiscounts,
    'illustration-shop': ImgShop,
    'illustration-smart-electricity': ImgSmartElectricity,
    'illustration-coffee': ImgCoffee,
    'illustration-electricity': ImgElectricity,
    'illustration-streetfood': ImgStreetFood,
    'illustration-warm-food': ImgWarmFood,
    'illustration-burgercoffee': ImgBurgerCoffee,
    'illustration-christmas': ImgChristmas,
    'illustration-meatballs': ImgMeatballs,
    'illustration-wrapilla': ImgWrapilla,
    'illustration-burger': ImgBurger,
    'illustration-grillburger': ImgGrillburger,
};